const Joi = require("joi");

const categorySchema = (data) => {
  const schema = Joi.object({
    committee: Joi.string()
      .trim()
      .pattern(new RegExp("^[a-zA-Z0-9 ]*$"))
      .required()
      .messages({
        "string.pattern.base": "Please enter Valid Committee Name.",
        "string.empty": "Please Select Committee.",
        "any.required": "Please Select Committee.",
      }),

    title: Joi.string().trim().required().messages({
      "string.empty": "Please enter title.",
      "any.required": "Please enter title.",
    }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = categorySchema;
